import { render, staticRenderFns } from "./RoomDescriptionDialog.vue?vue&type=template&id=478e6b02&"
import script from "./RoomDescriptionDialog.vue?vue&type=script&lang=ts&"
export * from "./RoomDescriptionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RoomDescriptionDialog.vue?vue&type=style&index=0&id=478e6b02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports